export const computeFileExtension = (
  fileName: string | undefined,
): string | null => {
  if (fileName?.includes('.')) {
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    return fileName.split('.').pop().toLowerCase();
  }

  return null;
};

export const getVersionAndTypeBeingDisplayed = (
  fileName: string,
): {
  fileName: string;
  ext: string | undefined;
  version: string | null;
} => {
  const [, rest] = fileName.split('_');
  const ext = fileName.split('.').at(-1);

  if (!rest) {
    return { fileName, ext, version: 'original' };
  }

  const splitRest = rest.split('.');
  const version = splitRest.slice(0, splitRest.length - 1).join('.');

  return { fileName, ext, version };
};
